/**
 * General Medicine comptesRendu Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import AppConfig from "../../../constants/AppConfig";
import {store} from "../../store";

// States
const state = {
    comptesRendus: [],
    compteRendu: {}
};

// Getters
const getters = {
    comptesRendu: state => {
        return state.comptesRendu
    },

    compteRendu: state => {
        return state.compteRendu
    }
};

// Actions
const actions = {
    // printcompteRenduMedecine(context, payload) {
    //     function successCallback(response) {
    //         let url= AppConfig.imgUrl+'/public/storage/pdf/'+response.data.name;
    //         let fileName = response.data.name;
    //
    //         Vue.axios.get(
    //             url,{
    //                 responseType: 'blob', // important
    //             }
    //         ).then((response) => {
    //
    //             const url = window.URL.createObjectURL(new Blob([response.data]));
    //             const link = document.createElement('a');
    //             link.href = url;
    //             link.setAttribute('download', fileName);
    //             document.body.appendChild(link);
    //             link.click();
    //         });
    //     }
    //
    //
    //     function errorCallback(error) {
    //         Vue.swal(
    //             payload.errorMessages.error,
    //             '',
    //             'error'
    //         );
    //     }
    //
    //     const localToken = localStorage.getItem('ms-token');
    //
    //     makeApiRequest(payload.args, apiModel.compteRendu.General.Print, localToken, successCallback, errorCallback, payload.errorMessages);
    // },


    getcomptesRendu(context, payload) {
        function successCallback(response) {
            context.commit('getCompteRenduHandler', { comptesRendu: response.data.comptesRendu });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.CompteRendu.Operatoire.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    printCompteRendu(context, payload) {
        function successCallback(response) {
            let url= AppConfig.imgUrl+'/public/storage/pdf/'+response.data.name;
            let fileName = response.data.name;

            Vue.axios.get(
                url,{
                    responseType: 'blob', // important
                }
            ).then((response) => {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            });
        }


        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.CompteRendu.Operatoire.Print, localToken, successCallback, errorCallback, payload.errorMessages);
    },


    getCompteRendu(context, payload) {
        function successCallback(response) {
            context.commit('getCompteRenduHandler', { compteRendu: response.data.compteRendu });
            context.commit('getMedicalFileHandler', { file: response.data.compteRendu.dossier });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.CompteRendu.Operatoire.Show, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createcompteRendu(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'compte-rendu', params: { compteRendu: response.data.compteRendu.slug } });


        }

        function errorCallback(error) {
            store.dispatch('record', {errors : error.response.data.error});
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.CompteRendu.Operatoire.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateCompteRendu(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            store.dispatch('findAndRemove', {name: 'compte-rendu' });

            router.push({ name: 'compte-rendu', params: { compteRendu: response.data.compteRendu.slug } });
        }

        function errorCallback(error) {
            // store.dispatch('record', {errors : error.response.data.error});
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        // let url = AppConfig.apiUrl + apiModel.CompteRendu.Operatoire.Create.url + '/' + payload.compteRendu;

        // Vue.axios.post(
        //     url,
        //     payload.args,
        //     {
        //         headers: {
        //             'Authorization': `Bearer ${localToken}`,
        //             'Content-Type': 'multipart/form-data'
        //         }
        //     }
        // )
        //     .then(successCallback)
        //     .catch(errorCallback);

        makeApiRequest(payload.args, apiModel.CompteRendu.Operatoire.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteCompteRendu(context, payload) {
        function successCallback(response) {
            // context.commit('deletecompteRenduHandler', { index: payload.index, successMessage: payload.successMessage });
            router.push((router.resolve({ name: 'medical-file',  params: { file: response.data.compteRendu.dossier.slug } }).href) +"#compteRenduOperatoire");
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.CompteRendu.Operatoire.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    archieveMedecinecompteRendu(context, payload) {
        function successCallback(response) {
            context.commit('archieveCompteRenduHandler', { index: payload.index, successMessage: payload.successMessage });
            context.commit('getCompteRenduHandler', { compteRendu: response.data.resultat });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.CompteRendu.Operatoire.Archieve, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    transmitMedecinecompteRendu(context, payload) {
        function successCallback(response) {
            context.commit('transmitCompteRenduHandler', { index: payload.index, successMessage: payload.successMessage });
            context.commit('getCompteRenduHandler', { compteRendu: response.data.resultat });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.CompteRendu.Operatoire.Transmit, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    reactiveMedecinecompteRendu(context, payload) {
        function successCallback(response) {
            context.commit('reactiveCompteRenduHandler', { index: payload.index, successMessage: payload.successMessage });
            context.commit('getCompteRenduHandler', { compteRendu: response.data.resultat });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.CompteRendu.Operatoire.Rearchieve, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getComptesRenduHandler(state, { comptesRendu }) {
        // Update comptesRendu state
        state.comptesRendu = comptesRendu;
    },

    getCompteRenduHandler(state, { compteRendu }) {
        // Update compteRendu state
        state.compteRendu = compteRendu;
    },

    deleteCompteRenduHandler(state, { index, successMessage }) {
        // let i = state.comptesRendu.findIndex(compteRendu => compteRendu.slug === index);
        //
        // if (~i) {
        //     state.comptesRendu.splice(i, 1);

        // router.push({ name: 'comptesRendu-generals' });


        Vue.swal(
            successMessage,
            '',
            'success'
        );
        // }
    },

    archieveCompteRenduHandler(state, { index, successMessage }) {
        // router.push({ name: 'comptesRendu-generals' });

        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },

    reactiveCompteRenduHandler(state, { index, successMessage }) {
        // router.push({ name: 'comptesRendu-generals' });

        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },

    transmitCompteRenduHandler(state, { index, successMessage }) {
        // router.push({ name: 'comptesRendu-generals' });

        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },

};

export default {
    state,
    getters,
    actions,
    mutations
}